import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from '@shared/services/constants/constants';
import { RouteNames } from 'src/app/routing/route-utils';

@Injectable({
  providedIn: 'root'
})

export class NavService {

  constructor(private router: Router
  ) { }

  public logintoAaos() {
    window.location.href = window.location.origin + Constants.ApiUrl.SsoLogin;
  }

  public goToRoster() {
    this.router.navigate(['/' + RouteNames.roster], { replaceUrl: true });
  }

  public goToOITE() {
    this.router.navigate(['/' + RouteNames.oite], { replaceUrl: true });
  }

  public goToPath(path: string) {
    this.router.navigate(['/' + path]);
  }

  public goToOverview() {
    this.router.navigate(['/' + RouteNames.overview], { replaceUrl: true });
  }

  public goToUnauthorized() {
    this.router.navigate(['/' + RouteNames.unauthorized], { replaceUrl: true });
  }

  public goToFaculty() {
    this.router.navigate(['/' + RouteNames.faculty], { replaceUrl: true});
  }

}
